import type { IconId } from './icons'

export type MenuKey =
  | 'dashboard_master'
  | 'dashboard_affiliate'
  | 'finance'
  | 'customers'
  | 'affiliates'
  | 'plans_admin'
  | 'vip_admin'
  | 'subscriptions'
  | 'subscriptions_beta'
  | 'member_plans'
  | 'member_billing'
  | 'reports'
  | 'reports_v2'
  | 'testimonials_admin'
  | 'faq_admin'
  | 'evolucoes'
  | 'affiliate_recebimentos'
  | 'affiliate_afiliacoes'
  | 'affiliate_comissoes'
  | 'affiliate_coupons'
  | 'oportunidades'
  | 'auditoria'
  | 'discount_coupons'
  | 'sugestoes'
  | 'analysis_cripto'
  | 'visoes'
  | 'chat'
  | 'rewards'
  | 'repasses'
  | 'system'

export type NavDef = {
  key: MenuKey
  label: string
  to: string
  roles: Array<'master' | 'member' | 'afiliado'>
  icon: IconId
}

export const NAV_DEFS: NavDef[] = [
  { key: 'dashboard_master', label: 'Painel', to: '/dashboard-master', roles: ['master'], icon: 'user-cog' },
  { key: 'dashboard_affiliate', label: 'Painel', to: '/dashboard-affiliate', roles: ['afiliado'], icon: 'users' },
  { key: 'finance', label: 'Financeiro', to: '/financeiro', roles: ['master'], icon: 'briefcase' },
  { key: 'customers', label: 'Clientes', to: '/customers', roles: ['master'], icon: 'user-cog' },
  { key: 'affiliates', label: 'Afiliados', to: '/affiliates', roles: ['master'], icon: 'users' },
  { key: 'plans_admin', label: 'Planos', to: '/plans', roles: ['master'], icon: 'credit-card' },
  { key: 'discount_coupons', label: 'Cupom', to: '/cupons', roles: ['master'], icon: 'tag' },
  { key: 'analysis_cripto', label: 'Analise Cripto', to: '/analise-cripto', roles: ['master', 'member', 'afiliado'], icon: 'pie-chart' },
  { key: 'visoes', label: 'Visoes', to: '/visoes', roles: ['master', 'member', 'afiliado'], icon: 'eye' },
  { key: 'chat', label: 'Chat', to: '/chat', roles: ['master', 'member', 'afiliado'], icon: 'message-square' },
  { key: 'rewards', label: 'Rewards', to: '/rewards', roles: ['master', 'member'], icon: 'gift' },
  { key: 'repasses', label: 'Repasses', to: '/repasses', roles: ['master', 'member', 'afiliado'], icon: 'layers' },
  { key: 'system', label: 'Sistema', to: '/settings', roles: ['master'], icon: 'settings' },
  { key: 'vip_admin', label: 'VIP', to: '/vip-admin', roles: ['master'], icon: 'star' },
  // Assinaturas: nova pÇ­gina oficial (v2) e pÇ­gina antiga (old) para consultas pontuais
  { key: 'subscriptions', label: 'Assinaturas (old)', to: '/subscriptions', roles: ['master'], icon: 'cpu' },
  { key: 'subscriptions_beta', label: 'Assinaturas', to: '/subscriptions-v2', roles: ['master'], icon: 'credit-card' },
  { key: 'oportunidades', label: 'Oportunidades', to: '/oportunidades', roles: ['master', 'member', 'afiliado'], icon: 'trending-up' },
  { key: 'sugestoes', label: 'Sugestões', to: '/sugestoes', roles: ['master', 'member', 'afiliado'], icon: 'message-circle' },
  { key: 'auditoria', label: 'Auditoria', to: '/auditoria', roles: ['master'], icon: 'file-text' },
  { key: 'testimonials_admin', label: 'Depoimentos', to: '/testimonials', roles: ['master'], icon: 'message-circle' },
  { key: 'faq_admin', label: 'FAQ', to: '/faq', roles: ['master'], icon: 'life-buoy' },
  { key: 'evolucoes', label: 'Evolucoes', to: '/evolucoes', roles: ['master', 'member', 'afiliado'], icon: 'file-text' },
  { key: 'affiliate_recebimentos', label: 'Recebiveis', to: '/recebimentos', roles: ['afiliado'], icon: 'credit-card' },
  { key: 'affiliate_afiliacoes', label: 'Afiliacoes', to: '/afiliacoes', roles: ['afiliado'], icon: 'users' },
  { key: 'affiliate_comissoes', label: 'Comissoes', to: '/comissoes', roles: ['afiliado'], icon: 'chart-bar' },
  { key: 'affiliate_coupons', label: 'Cupom', to: '/meus-cupons', roles: ['afiliado'], icon: 'tag' },
  { key: 'member_plans', label: 'Planos', to: '/my-plans', roles: ['member'], icon: 'credit-card' },
  { key: 'member_billing', label: 'Assinatura', to: '/assinatura', roles: ['member'], icon: 'credit-card' },
  { key: 'reports', label: 'Relatorios', to: '/reports', roles: ['master'], icon: 'line-chart' },
  { key: 'reports_v2', label: 'Relatório V2', to: '/relatorio-v2', roles: ['master'], icon: 'chart-bar' },
]
